import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import { FloatingPanelSeparator } from "@babackapp/ui/components/floating-panel";
import { ButtonBlockProps } from "./types";
import { EmailPanelLabel } from "./email-panel-label";
import { EmailPanelUrl } from "./email-panel-url";
import { EmailPanelStyle } from "./email-panel-style";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import PanelBlockFont from "../../lib/panel/panel-block-font";

export function ButtonEmailPanelRenderer(blockProps: ButtonBlockProps) {
  return (
    <PanelContainer blockProps={blockProps}>
      <EmailPanelLabel />
      <FloatingPanelSeparator />
      <EmailPanelUrl />
      <FloatingPanelSeparator />
      <EmailPanelStyle />
      <FloatingPanelSeparator />
      <PanelBlockFont />
      <PanelBlockAlignment />
      <PanelTranslationState mode="translatable" portal />
    </PanelContainer>
  );
}
